import { styled } from "@mui/material/styles";
import AvatarIcon from "../../assets/icons/Avatar.js";
import LogoIcon from "../../assets/icons/Logo.js";
import "react/jsx-runtime";
import "@mui/material";
const AVATAR_SIZE = "32px";
const Container = styled("div", {
  shouldForwardProp: (props) => props !== "$isPatient" && props !== "$defaultAvatar" && props !== "$image"
})(({ $defaultAvatar, $image, $isPatient }) => ({
  border: "2px solid #F5F5F5",
  borderRadius: "50%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundColor: "#E0E0E0",
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  color: "#424242",
  textTransform: "uppercase",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  flexShrink: 0,
  overflow: "hidden",
  ...$image && {
    backgroundImage: `url(${$image})`
  },
  ...$isPatient && {
    backgroundSize: "20px 20px"
  },
  ...$defaultAvatar && {
    backgroundImage: `url('../../assets/images/Logo.svg')`,
    backgroundColor: "#00624F",
    backgroundSize: "70%",
    border: "none"
  }
}));
const AvatarImage = styled("img")(() => ({
  visibility: "hidden"
}));
const PatientAvatar = styled(AvatarIcon)(() => ({
  width: 18
}));
const Logo = styled(LogoIcon)(() => ({
  width: 18
}));
export {
  AvatarImage,
  Container,
  Logo,
  PatientAvatar
};
